'use client';

import React from "react";
import { Coffee, Circle, XCircle } from "lucide-react";
import { useTeam } from "../internals";

// Lifted verbatim from Kreta RT1 §1.3 — status badge styles + icons.
const STYLES = {
  active: { cls: "bg-green-50 text-green-700 border-green-200", Icon: Circle },
  on_leave: { cls: "bg-amber-50 text-amber-700 border-amber-200", Icon: Coffee },
  inactive: { cls: "bg-gray-100 text-gray-600 border-gray-200", Icon: Circle },
  resigned: { cls: "bg-red-50 text-red-600 border-red-200", Icon: XCircle },
};

const LABEL_KEY = {
  active: "status_active",
  on_leave: "status_on_leave",
  inactive: "status_inactive",
  resigned: "status_resigned",
};

export const StatusBadge = ({ status }) => {
  const { copy } = useTeam();
  const { cls, Icon } = STYLES[status] || STYLES.active;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium ${cls}`}
    >
      <Icon size={10} />
      {copy[LABEL_KEY[status]] || status}
    </span>
  );
};
